export default __webpack_public_path__ + "static/media/granville24.6d758a1f.jpg";